/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./api";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const doRetrigger = /* GraphQL */ `mutation DoRetrigger($traceId: String!) {
  doRetrigger(traceId: $traceId) {
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DoRetriggerMutationVariables,
  APITypes.DoRetriggerMutation
>;
